import React, { FC } from "react";
import classnames from "classnames";
import { Typography } from "legal/imports/components";
import { TYPOGRAPHY_TYPE } from "legal/imports/constants";
import styles from "./LegalTypography.scss";

interface ParagraphProps {
  subParagraph?: boolean;
  subSubParagraph?: boolean;
}

const Paragraph: FC<ParagraphProps> = ({
  subParagraph,
  subSubParagraph,
  children,
}) => (
  <Typography
    type={TYPOGRAPHY_TYPE.PARAGRAPH4}
    className={classnames(styles.paragraph, {
      [styles.subParagraph]: subParagraph,
      [styles.subSubParagraph]: subSubParagraph,
    })}
    as="p"
  >
    {children}
  </Typography>
);

export default Paragraph;
